import React from 'react';
import { FormattedMessage } from 'react-intl';

const ExternalCalSelectionStrings = {
  selectSpaceTitle: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.external_cal_selection.title_select_space"
      defaultMessage="Select space"
    />
  ),
  selectCalTypeTitle: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.external_cal_selection.title_select_type"
      defaultMessage="Select calendar type"
    />
  ),
  syncCalendarTitle: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.button_sync"
      defaultMessage="Sync calendar"
    />
  ),
  syncCalendarDesc: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.external_cal_selection.desc_select_space"
      defaultMessage="Allows for two-way sync on your external calendar: Google, iCloud, Office 365, Exchange, and Outlook"
    />
  ),
  icalTitle: (
    <FormattedMessage
      id="hosting.calendar_main.external_calendar_modal_ical"
      defaultMessage="Import iCalendar (iCal) URL"
    />
  ),
  icalDesc: (
    <FormattedMessage
      id="hosting.calendar_main.external_calendar_modal_companies"
      defaultMessage="Airbnb, VRBO, and other calendars"
    />
  )
};

export default ExternalCalSelectionStrings;
